import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid h-full grid-cols-4" }
const _hoisted_2 = { class: "col-span-1 border-r bg-primary-dark" }
const _hoisted_3 = {
  key: 0,
  class: "pl-3 border-b-2"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Select a Class: ")
const _hoisted_5 = { class: "h-full col-span-3 overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_syllabus_explorer = _resolveComponent("syllabus-explorer")
  const _component_scroll_container = _resolveComponent("scroll-container")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.userIsStudent)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createVNode("select", {
              ref: "selectRef",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentCourse = $event)),
              class: "p-1 my-2 border rounded focus:outline-none",
              "data-testid": "syllabus-select"
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.courseGroupSyllabusOptions, (courseGroup) => {
                return (_openBlock(), _createBlock("optgroup", {
                  key: courseGroup.groupLabel,
                  label: courseGroup.groupLabel
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(courseGroup.syllabusLabels, (syllabus, syllabusIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      key: syllabusIndex,
                      value: syllabus
                    }, _toDisplayString(syllabus.label), 9, ["value"]))
                  }), 128))
                ], 8, ["label"]))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.currentCourse]
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_scroll_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_syllabus_explorer, {
            syllabus: _ctx.syllabus,
            activeChapterName: _ctx.activeChapterName,
            activeTopicName: _ctx.activeTopicName,
            activeEventName: _ctx.activeEventName,
            onChapterSelected: _ctx.handleChapterSelected,
            onTopicSelected: _ctx.handleTopicSelected,
            onEventNameSelected: _ctx.handlEventNameSelected
          }, null, 8, ["syllabus", "activeChapterName", "activeTopicName", "activeEventName", "onChapterSelected", "onTopicSelected", "onEventNameSelected"])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ]))
}